import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './styles.css';

/**
 * App Bridge is loaded by a static <script> tag in index.html, not from here.
 *
 * Requirement 2.2.3 requires app-bridge.js to come before any other script tag,
 * and this module IS a script tag — so injecting it from here was always too
 * late, however well it appeared to work.
 *
 * A note for anyone tempted to move it back: it worked fine. App Bridge
 * initialised, session tokens minted, everything green in dev. The requirement
 * is about load order, and load order is not something the app can observe
 * about itself.
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
